window.addEventListener('load', function(){


document.querySelectorAll('.custom-button-collapsible').forEach(item => {
 var content = item.nextElementSibling;
 var icon = item.querySelector('.custom-collapsible-icon, #custom-collapsible-icon');
 var isCollapsed = item.dataset.collapsed === 'true';

 if (isCollapsed) {
  content.style.maxHeight = null;
  item.setAttribute('aria-expanded', 'false');
  if (icon) {
    icon.style.transform ="rotate(180deg)";
  }
 } else {
  content.style.maxHeight = content.scrollHeight + "px";
  item.setAttribute('aria-expanded', 'true');
  if (icon) {
    icon.style.transform ="rotate(0deg)";
  }
 }

 item.addEventListener('click',  function() {
  this.classList.toggle("active");
  if(content.style.maxHeight){
    content.style.maxHeight = null;
    this.setAttribute('aria-expanded', 'false');
    if (icon) {
      icon.style.transform ="rotate(180deg)";
    }
  }else{
    content.style.maxHeight = content.scrollHeight + "px";
    this.setAttribute('aria-expanded', 'true');
    if (icon) {
      icon.style.transform ="rotate(0deg)";
    }
  }
 })
})

  // These dropdowns use <table> purely for visual layout of their content
  // (product description, important information, ...). Expose them as
  // presentational so screen readers read the content linearly instead of
  // announcing rows/columns like a data table.
  document.querySelectorAll('.custom-product-description-sections table').forEach(table => {
    table.setAttribute('role', 'presentation');
  });
})
